/**
 * The door to the new design's home page — prest0.ai/ itself since 2026-09-24 (config/site-design.json lists `home`
 * as live), and prest0.ai/prest0design/, the demonstration address.
 *
 * App.tsx renders it for the route `/` wherever designShows('home'), and src/index.tsx starts its chunks at boot
 * (both lines are pinned by tests/hooks/unauthedLandingResilient.test.ts). Since PV1b it is a thin wrapper: every
 * page of the new design goes through one door, ./withPavilion.tsx, which loads the shell and then the page's own
 * chunk (`pavilion-home`) through the shell's registry.
 */
import React from 'react';
import { PavilionDoor, preloadPavilion } from './withPavilion';

/** Start fetching the home page's chunks before the first render (src/index.tsx, on `/`). Never throws. */
export function preloadPavilionHome(): void {
  preloadPavilion('home');
}

export interface PavilionHomeDoorProps {
  /** What renders if the new design's chunks cannot be loaded: today's home page. */
  fallback: React.ReactNode;
}

const PavilionHomeDoor: React.FC<PavilionHomeDoorProps> = ({ fallback }) => <PavilionDoor pageKey="home" fallback={fallback} />;

export default PavilionHomeDoor;
